import { Check, Mic, X } from "lucide-react";

import {
  AudioRecordContextStatus,
  useAudioRecorder,
} from "./use-audio-recorder";

export const AudioButtonRecording: React.FC<{
  recorder: ReturnType<typeof useAudioRecorder>;
  onStartRecording?: () => void;
  onStopRecording?: () => void;
}> = ({
  recorder,
  onStartRecording = () => void 0,
  onStopRecording = () => void 0,
}) => {
  return recorder.status !== AudioRecordContextStatus.Recording ? (
    <button
      title="record"
      type="button"
      onClick={() => {
        recorder.startRecording();
        onStartRecording();
      }}
      className="shadow-btn btn-neutral btn-sm btn ml-auto grid h-10 w-12 place-content-center rounded-btn"
    >
      <Mic width={20} />
    </button>
  ) : (
    <button
      title="record"
      type="button"
      onClick={() => {
        recorder.stopRecording();
        onStopRecording();
      }}
      className="shadow-btn btn-neutral btn-sm btn ml-auto grid h-10 w-12 place-content-center rounded-btn"
    >
      <Check width={20} />
    </button>
  );
};

export const AudioDiscardButton: React.FC<{
  recorder: ReturnType<typeof useAudioRecorder>;
}> = ({ recorder }) => {
  return recorder.status === AudioRecordContextStatus.Playback ? (
    <button
      title="delete"
      type="button"
      className="shadow-btn btn-sm btn h-10 w-12 border border-neutral-200 bg-neutral-100"
      onClick={recorder.deleteRecording}
    >
      <X width={20} />
    </button>
  ) : null;
};
